
import { useEffect, useRef, useState } from "react";
import { Form, FormGroup, FormLabel, FormControl, Row, Col } from "react-bootstrap"
import { PostCallWithErrorResponse, multipartPostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../Api/ApiServices";
import { ApiConfig, BASE_URL } from "../Api/ApiConfig";
import { convertToFormData, isValidURL } from "../common";
import { toastMsg } from "../component/toast";
import CustomSelect from "../constant/customselect";
import { companyQues } from "../constant/companyQues";
import CustomButton from "../component/button";
import { companySize, companyType } from "../constant/jobType";
import { Modal } from "react-bootstrap";




function AddCompany({ handleSubmitClose, isHandle = false, id, updateAboutCompany, isUpdateAboutCompany, isModal = false }) {
    const [valiteded, setValiteded] = useState(false);

    const picImg = useRef()

    const [compnayDetails, seTCompanyDetails] = useState({
        id: 0,
        companyName: "",
        headQuarters: "",
        aboutCompany: "",
        industry: "",
        companyWebsite: "",
        companyType: "",
        companySize: "1-10",
        companyLogo: '',
        CompanyLogoFile: '',
        companyQA: []

    })

    const [errorMsg, setErrorMsg] = useState({})

    const initualQues = [
        {
            "id": 0,
            "question": "",
            "answer": ""
        },
        {
            "id": 0,
            "question": "",
            "answer": ""
        },
        {
            "id": 0,
            "question": "",
            "answer": ""
        },
    ]



    const [questions, setQues] = useState(initualQues)
    const [isLoading, setIsLoading] = useState(false)
    const handleQuesChange = (index, questionText, answerText) => {
        const updatedQues = [...questions];
        updatedQues[index] = {
            ...updatedQues[index],
            question: questionText,
            Answer: answerText,
        };
        console.log(updatedQues);
        setQues(updatedQues);
        console.log();

    }

    const [industries, setIndustries] = useState([])

    const getIndustries = () => {

        simpleGetCallWithErrorResponse(ApiConfig.GET_INDUSTRY_LIST).then((res) => {

            if (res?.json?.succeded) {

                setIndustries(res?.json?.response)
            } else {
                setIndustries([])
            }

        })
    }

    useEffect(() => {
        getCompanyDetailsForUpdate()
        getIndustries()
    }, [])


    const getCompanyDetailsForUpdate = () => {
        if (!id) return
        simpleGetCallWithErrorResponse(ApiConfig.GET_COMPANY_DETAIL + id).then((res) => {

            if (res?.json?.succeded) {
                seTCompanyDetails(res?.json?.response)
                console.log(JSON.parse(res?.json?.response?.companyQA));
                setQues(JSON.parse(res?.json?.response?.companyQA))
            } else {
                toastMsg('error', "Something went wrong try again")
            }

        })

    }

    const handleSubmit = (event) => {
        event?.preventDefault();
        event?.stopPropagation();

        let isvalid = true

        if (compnayDetails?.companyWebsite?.length && !isValidURL(compnayDetails?.companyWebsite)) {
            toastMsg('error', 'Please Enter Valid Website Url')
            isvalid = false
        }

        if (!compnayDetails?.industry) {
            setErrorMsg(prev => ({
                ...prev,
                industryErr: 'Please Select Industry'
            }))
            isvalid = false
        }

        const form = event?.currentTarget;
        if (!form?.checkValidity()) {
            console.log(form?.checkValidity());
            setValiteded(true);
            return;
        }



        if ((!questions[0]?.answer || !questions[1]?.answer || !questions[2]?.answer) &&
            (!questions[0]?.Answer || !questions[1]?.Answer || !questions[2]?.Answer)
        ) {
            toastMsg('error', "Please Select Answer of Questions")
            isvalid = false
        }

        if (!isvalid) return

        compnayDetails.companyQA = JSON.stringify(questions)

        let formData = convertToFormData(compnayDetails)

        setIsLoading(true)
        multipartPostCallWithErrorResponse(ApiConfig.ADD_UPDATE_COMP, formData).then((res) => {

            if (res?.json?.succeded) {
                toastMsg('success', res?.json?.response?.statusMessage)

                if (isHandle) {

                    handleSubmitClose()
                }

                if (isUpdateAboutCompany) {
                    updateAboutCompany(compnayDetails?.aboutCompany, compnayDetails?.companyName)
                }

            } else {
                toastMsg('error', res?.json?.response?.statusMessage)
            }
            setIsLoading(false)
        })
    }

    const handleChange = (key, val) => {


        seTCompanyDetails(prev => ({
            ...prev,
            [key]: val
        }))

    }
    const [imgError, setImgError] = useState(false);
    useEffect(() => {
        setImgError(false);
    }, [compnayDetails?.CompanyLogoFile, compnayDetails?.companyLogo]);
    return (
        <>
            <Form noValidate validated={valiteded} onSubmit={handleSubmit}>
                <div className="modalBody">
                    <div className="">
                        <div style={{ marginBottom: '8px' }}>
                            {

                                (compnayDetails?.CompanyLogoFile || compnayDetails.companyLogo) && !imgError &&

                                <img
                                    src={compnayDetails?.CompanyLogoFile ? URL.createObjectURL(compnayDetails?.CompanyLogoFile)
                                        : BASE_URL + compnayDetails?.companyLogo
                                    }
                                    onError={() => setImgError(true)}
                                    // alt='Image not found'
                                    style={{
                                        height: '80px',
                                        width: '166px',
                                        borderRadius: '8px',
                                        objectFit: 'contain'
                                    }}
                                    accept="image/*"

                                />
                            }
                        </div>

                        <div className=" mb-3">
                            <input ref={picImg} type="file" style={{ display: 'none' }}
                                onChange={(e) => handleChange('CompanyLogoFile', e.target.files[0])}
                            />
                            <CustomButton
                                isLoading={false}
                                buttonType="secondary"
                                title={compnayDetails?.CompanyLogoFile || compnayDetails.companyLogo ? 'Change Company Logo' : "Upload Company Logo"}
                                handleClick={() => picImg.current.click()}
                            />
                        </div>

                    </div>
                    <Form.Group controlId="designation" className="mb-3">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size">Company Name</Form.Label>
                            </Col>
                            <Col sm={9}>
                                {/* <Form.Label className="job_size">Company Name</Form.Label> */}
                                <Form.Control
                                    type="text"
                                    className="input-text-14"
                                    required
                                    placeholder="Company Name"
                                    value={compnayDetails?.companyName}
                                    onChange={(e) => handleChange('companyName', e.target.value)}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please Enter Company Name!
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group controlId="designation" className="mb-3">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size "

                                >Industries</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <CustomSelect

                                    // label="Industries"
                                    options={industries}
                                    valKey={'label'}
                                    labelKey="label"
                                    value={compnayDetails?.industry}
                                    handleChange={(e) => {

                                        setErrorMsg(prev => ({
                                            ...prev,
                                            industryErr: e ? "" : 'Please Select Industry'
                                        }))
                                        handleChange('industry', e)
                                    }}
                                    size="small"
                                />
                                {
                                    <span className="errormSg">
                                        {errorMsg?.industryErr}
                                    </span>
                                }

                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group controlId="designation" className="mb-3">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size">Company Website</Form.Label>
                            </Col>
                            <Col sm={9}>
                                <Form.Control
                                    type="text"
                                    className="input-text-14"

                                    placeholder="Company Website"
                                    value={compnayDetails?.companyWebsite}
                                    onChange={(e) => handleChange('companyWebsite', e.target.value.trim())}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please Enter Company Website!
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>


                    <Form.Group controlId="designation" className="mb-3">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size">Company Type</Form.Label>
                            </Col>
                            <Col sm={9}>

                                <Form.Select aria-label="Default select example"

                                    value={compnayDetails?.companyType}
                                    onChange={(e) => handleChange('companyType', e.target.value)}
                                    className="selectPlaceholder"
                                    placeholder="Select Company Type"

                                >
                                    <option value={""} disabled>Select Company Type</option>
                                    {
                                        companyType?.map((type, index) => {
                                            return <option value={type} key={index}
                                                className="job_size"
                                                style={{ fontSize: "14px", color: "red" }}
                                            >{type}</option>
                                        })
                                    }

                                </Form.Select>

                                <Form.Control.Feedback type="invalid">
                                    Please Enter Company Type!
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group controlId="designation" className="mb-3">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size">Company Size
                                </Form.Label>
                            </Col>
                            <Col sm={9}>

                                <Form.Select aria-label="Default select example"

                                    value={compnayDetails?.companySize}
                                    onChange={(e) => handleChange('companySize', e.target.value)}

                                >
                                    {
                                        companySize?.map((size, index) => {
                                            return <option value={size} key={index}>{size}</option>
                                        })
                                    }
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">
                                    Please Enter Select Company-Size!
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group controlId="designation" className="mb-3">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size">Head Quarters</Form.Label>
                            </Col>
                            <Col sm={9}>

                                <Form.Control
                                    type="text"
                                    className="input-text-14"
                                    placeholder="Head Quarters"
                                    value={compnayDetails?.headQuarters}
                                    onChange={(e) => handleChange('headQuarters', e.target.value)}

                                />
                                <Form.Control.Feedback type="invalid">
                                    Please Enter Head Quarters!
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group controlId="designation" className="">
                        <Row className="align-items-center">
                            <Col sm={3}>
                                <Form.Label className="job_size">About Company</Form.Label>
                            </Col>
                            <Col sm={9}>

                                <Form.Control
                                    as="textarea"
                                    className="input-text-14"
                                    required
                                    placeholder="About Company"

                                    value={compnayDetails?.aboutCompany}
                                    onChange={(e) => {



                                        handleChange('aboutCompany', e.target.value)

                                    }}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please Enter About Company!
                                </Form.Control.Feedback>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Modal.Header className="mb-4">
                        <h6 className="mb-0"></h6>
                    </Modal.Header>
                    {
                        companyQues?.map((ques, index) => {

                            return <Form.Group key={index} controlId={`question-${index}`} className="mb-3"
                            >
                                <Form.Label className="qstn-addjob fw-bold">{ques?.ques}</Form.Label>
                                {
                                    Object.keys(ques?.options)?.map((opt) => {
                                        return <Form.Check
                                            type="radio"
                                            label={
                                                <div style={{ color: "inherit" }}>
                                                    <span className="fw-bold">{opt} :</span> {ques?.options[opt]}
                                                </div>
                                            }
                                            name={`radioGroup-${index}`}
                                            value={opt}
                                            required
                                            checked={questions[index]?.answer === opt || questions[index]?.Answer === opt}
                                            onChange={() => handleQuesChange(index, ques?.ques, opt)}
                                            className="answr-addjob"
                                        />
                                    })
                                }


                            </Form.Group>

                        })
                    }
                </div>

                <div className="d-flex justify-content-end mt-4 mb-2">
                    <CustomButton
                        isLoading={isLoading} title={id ? "Update" : "Submit"}
                        type='submit'
                    />

                </div>
            </Form >
        </>
    )

}

export default AddCompany